import activitiesJson from "./legacy/items/activities.json";
import ActivitiesAllJson from "./legacy/items/activities-all.json";
import activitiesHierachicalJson from "./legacy/items/activivities-hierachical.json";

import activityJson from "./legacy/items/activity.json";

import locationsJson from "./legacy/items/locations.json";
import locationJson from "./legacy/items/location.json";

import locationsAllJson from "./legacy/items/locations-all.json";
import locationsHierachicalJson from "./legacy/items/locations-hierachical.json";
import locationsActivityMapping from "./legacy/items/locations-activity-mapping.json";

import SearchByActivity from "./legacy/search/locations-in-badminton.json";
import SearchByLocation from "./legacy/search/activities-in-hafniahallen.json";
import SearchPeriodsJson from "./legacy/search/periods-badminton.json";
import SearchPeriodsInlineJson from "./legacy/search/periods-badminton-inline.json";

import SearchPeriodPrioritizedJson from "./legacy/search/periods-badminton-prioritized.json";
import SearchPeriodsPrioritizedInlineJson from "./legacy/search/periods-badminton-inline-prioritized.json";

import apiV3SearchPeriodsJson from "./apiv3/search/mock-periods.json";
import apiV3ResourcesJson from "./apiv3/search/mock-resources.json";
import apiV3ResourcesMapJson from "./apiv3/search/mock-resources-map.json";

import apiV3CheckPeriodAvailableResponse from "./apiv3/checkout/check-available-resource.json";
import apiV3CheckPeriodUnavailableResponse from "./apiv3/checkout/check-unavailable-resource.json";

import footerJson from "./legacy/site/footer.json";

// import apiV3bookingPeriodEntries from "./apiv3/booking-period-resource-entries/entries.json";
import apiV3resourceEntries from "./apiv3/resources/resource-entries.json";

import apiV3FixedSearch from "./apiv3/search/periods-fixed/fixed-search.json";
import apiV3FixedAvailable from "./apiv3/search/periods-fixed/fixed-available.json";

import PaymentUrl from "./legacy/checkout/getPaymentUrl.json";

export default function DummyApi(
    ENV,
    Log,
    localStorageService,

    TestkitFactory
) {
    const fn = this;

    const localStorageKey = "enableDummyApi";

    fn.constructor = function () {
        fn.isEnabled() ? console.warn("Dummy Data is enabled") : null;
    };

    fn.toggleEnableDummyApi = function () {
        // flip
        let isEnabled = !fn.isEnabled();

        localStorageService.set(localStorageKey, isEnabled);

        return isEnabled;
    };

    fn.isEnabled = function () {
        return ENV.enableDummyApi &&
            JSON.parse(localStorageService.get(localStorageKey))
            ? true
            : false;
    };

    fn.getActivity = function () {
        const json = activityJson;
        fn.log("getActivity - basket", json, "legacy");
        return json;
    };

    fn.getActivities = function () {
        const json = activitiesJson;
        fn.log("getActivities", json, "legacy");
        return json;
    };

    fn.getActivitiesAll = function () {
        const json = ActivitiesAllJson;
        fn.log("getActivitiesAll", json, "legacy");
        return json;
    };

    fn.getActivitiesHierachical = function () {
        const json = activitiesHierachicalJson;
        fn.log("getActivitiesHierachical", json, "legacy");
        return json;
    };

    fn.getLocation = function () {
        const json = locationJson;
        fn.log("getLocation - Bellahøjhallerne", json, "legacy");

        return json;
    };

    fn.getLocations = function () {
        const json = locationsJson;
        fn.log("getLocations", json, "legacy");

        return json;
    };

    fn.getLocationsAll = function () {
        const json = locationsAllJson;
        fn.log("getLocationsAll", json, "legacy");

        return json;
    };

    fn.getLocationsHierachical = function () {
        const json = locationsHierachicalJson;
        fn.log("getLocationsHierachical", json, "legacy");
        return json;
    };

    fn.getLocationActivityMapping = function () {
        const json = locationsActivityMapping;
        fn.log("locationsActivityMapping", json, "legacy");
        return json;
    };

    /**
     * Search
     */
    fn.getSearchByActivity = function () {
        const json = SearchByActivity;
        fn.log("get search locations : Badminton", json, "legacy");
        return json;
    };

    fn.getSearchByLocation = function ($locationName) {
        const json = SearchByLocation;
        fn.log("get search activities : Hafnia hallen", json, "legacy");
        return json;
    };

    /**
     * NOT IN USE
     * Could be used to set search URL date when dummy
     */
    // fn.getDummySearchDate = function () {
    //     // must have a matching getPeriodsInline
    //     const json = SearchPeriodsJson;

    //     console.log(json);

    //     // fn.log("getPeriods - Badminton - Hafnia-hallen", json);

    //     return json.SearchDate;
    // };

    fn.getSearchPeriods = function () {
        // must have a matching getPeriodsInline
        let json = SearchPeriodPrioritizedJson;

        json = TestkitFactory.createTestKitSearch(json);

        fn.log(
            "getPeriods - Badminton - Hafnia-hallen TEST KIT 2050",
            json,
            "legacy"
        );

        return json;
    };

    fn.getPeriodsInline = function () {
        // must have a matching getSearchPeriods
        const json = SearchPeriodsPrioritizedInlineJson;
        fn.log("getPeriods inline - Badminton - Hafnia-hallen", json, "legacy");
        return json;
    };

    /**
     * SITE
     */
    fn.getFooter = function () {
        const json = footerJson;
        fn.log("Footer", json, "legacy");
        return json;
    };

    /**
     * APIV3
     *
     */
    fn.checkPeriodSetAvailabilityTo = function (respondAvailable) {
        const json = respondAvailable
            ? apiV3CheckPeriodAvailableResponse
            : apiV3CheckPeriodUnavailableResponse;

        fn.log("check resource availability - respond : ", json, "APIv3");

        return json;
    };

    fn.getAvailablePeriods = function () {
        // must have a matching getPeriodsInline
        const json = apiV3SearchPeriodsJson;

        fn.log(
            "APIv3 - getAvailablePeriods - Badminton - Hafnia-hallen",
            json,
            "APIv3"
        );

        return json;
    };

    fn.getResourceMap = function () {
        // must have a matching getPeriodsInline
        const json = apiV3ResourcesMapJson;

        fn.log("APIv3 - getResourceMap", json, "APIv3");

        return json;
    };

    fn.getResources = function () {
        // must have a matching getPeriodsInline
        const json = apiV3ResourcesJson;

        fn.log("APIv3 - getResources - Hafnia-hallen", json, "APIv3");

        return json;
    };

    // fn.get_entriesExtension = function (periodId, iteratorIndex) {
    //     let json = apiV3bookingPeriodEntries;

    //     let offset = json.length * iteratorIndex;

    //     const foundDbEntries = [33, 32, 31, 30, 29, 28, 27, 26, 25];

    //     let entries = [];

    //     json.forEach((item, index) => {
    //         let entry = angular.copy(item); // must use to avoid ref hell

    //         // TEST scenario : entry.resourceEntryId means that api update will not find it
    //         if (entry.resourceEntryId !== false) {
    //             entry.resourceEntryId = foundDbEntries[offset + index];
    //         }

    //         entry.bookingPeriodId = periodId;

    //         entries.push(entry);
    //     });

    //     fn.log("APIv3 - bookingPeriodEntries", entries, "APIv3");

    //     return entries;
    // };

    fn.getResourceEntries = (resourceId, iteratorIndex) => {
        let json = apiV3resourceEntries;

        // let offset = json.length * iteratorIndex;

        // const foundDbEntries = [33, 32, 31, 30, 29, 28, 27, 26, 25];

        let entries = [];

        json.forEach((item, index) => {
            let entry = angular.copy(item); // must use to avoid ref hell

            // TEST scenario : entry.resourceEntryId means that api update will not find it
            if (entry.resourceId !== false) {
                entry.resourceId = resourceId; //foundDbEntries[offset + index];
            }

            entries.push(entry);
        });

        fn.log("APIv3 - bookingPeriodEntries", entries, "APIv3");

        return entries;
    };

    fn.getFixedSearch = (resourceId, iteratorIndex) => {
        let json = apiV3FixedSearch;

        fn.log("APIv3 - getFixedSearch", json, "APIv3");

        return json;
    };

    fn.getFixedAvailable = (resourceId, iteratorIndex) => {
        let json = apiV3FixedAvailable;

        fn.log("APIv3 - getFixedAvailable", json, "APIv3");

        return json;
    };

    fn.getPaymentUrl = (resourceId, iteratorIndex) => {
        const json = PaymentUrl;

        fn.log("PaymentUrl", json, "legacy");

        return json;
    };

    /**
     * Utilz
     */

    fn.log = function (str, json, theme) {
        Log.obj(theme + " API: " + str, json, theme);
    };

    fn.constructor();

    return fn;
}
